<template>
  <ParkingContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ParkingContent from "../../components/Parking/ParkingContent.vue";

export default defineComponent({
  name: "ParkingPage",
  components: {
    ParkingContent,
  },
});
</script>
